import React from 'react';

export const UpdateProgramProjectedUpliftActivityFeedItemDescription = props => {
    let title = props.CustomEventData ? props.CustomEventData.title : "";
    let action = "modified";
    if (props.CustomEventData && props.CustomEventData.action) {
        action = props.CustomEventData.action;
    }

    return <p>
        {props.Event.Activity.User.name} {action} a Program Environmental Benefit.
    </p>;
};


